export default function ErrorPage() {
  return (
    <div>O_o</div>
  );
} 